import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeeConfirmationService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { 
    try{
      environment.API_URL = this.session.GetUserDetails().ApiUrl;
    }catch(e){}
  }

  ESS_ConfirmationRule_InsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ConfirmationRule_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_ConfirmationRuleLoad(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ConfirmationRule/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  
  ESS_QuestionnareTemplate_Insert(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_QuestionnareTemplate_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_QuestionnareTemplate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_QuestionnareTemplate/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmployeeConfirmationDetails(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ConfirmationModule/ComboLoad`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmployeeConfirmationDetails_InsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmployeeConfirmationDetails_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmployeeConfirmationDetailsSelect(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmployeeConfirmationDetails/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmployeeConfirmationQuestionnare(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmployeeConfirmation/Questionnare`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmployeeConfirmation_BulkInsert(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmployeeConfirmation_Bulk/Insert`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
